import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=f403a4b6&scoped=true"
import script from "./TemplateCard.vue?vue&type=script&lang=ts"
export * from "./TemplateCard.vue?vue&type=script&lang=ts"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=f403a4b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f403a4b6",
  null
  
)

export default component.exports